// Variant Picker JavaScript
document.addEventListener('DOMContentLoaded', function() {
  // Handle variant card selection
  document.addEventListener('change', function(e) {
    if (e.target.type === 'radio' && e.target.name.includes('option')) {
      // Remove active class from all variant cards
      document.querySelectorAll('.variant-card').forEach(card => {
        card.classList.remove('variant-card--active');
      });
      
      // Add active class to the selected card
      const selectedCard = e.target.closest('.variant-card');
      if (selectedCard) {
        selectedCard.classList.add('variant-card--active');
      }
    }
  });
  
  // Handle direct card clicks
  document.addEventListener('click', function(e) {
    const card = e.target.closest('.variant-card');
    if (card && !card.classList.contains('variant-card--active')) {
      // Remove active class from all cards
      document.querySelectorAll('.variant-card').forEach(c => {
        c.classList.remove('variant-card--active');
      });
      
      // Add active class to clicked card
      card.classList.add('variant-card--active');
      
      // Trigger the radio button
      const radio = card.querySelector('input[type="radio"]');
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
});
